import React from "react";

const TabEventos = ({
  handleSubmitEvento,
  formEvento,
  handleInputChangeEvento,
  handleFileChangeEvento,
  evento,
  handleOpenDeleteEventoModal,
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-5">
      {/* Formulario de registro */}
      <div className="sm:col-span-1 flex justify-center w-full tamanoConenedor scrollbar styleScrollbar margenResultado">
        <form
          onSubmit={handleSubmitEvento}
          className="md:max-w-md max-w-xs mx-auto mt-5 border border-gray-200 rounded-lg p-6 shadow-md"
        >
          <div className="flex justify-center mb-6">
            <label className="text-2xl font-semibold text-[#1E429F] flex items-center">
              <i className="bx bxs-map-pin text-[#1E429F] mr-2"></i> Registro de
              Eventos
            </label>
          </div>

          {/* Campo de Nombre */}
          <div className="mb-6">
            <div className="text-center mb-1">
              <label className="text-sm font-medium text-gray-700">
                Nombre
              </label>
            </div>
            <input
              type="text"
              name="nombre"
              value={formEvento.nombre}
              onChange={handleInputChangeEvento}
              className="w-full px-4 py-3.5 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200 text-sm"
              placeholder="Nombre del evento"
              required
            />
          </div>

          {/* Campo de Imagen */}
          <div className="mb-6">
            <div className="text-center mb-1">
              <label className="text-sm font-medium text-gray-700">
                Imagen
              </label>
            </div>
            <div className="flex items-center bg-gray-50 rounded-xl p-2">
              <button
                type="button"
                onClick={() =>
                  document.getElementById("evento-image-upload").click()
                }
                className="bg-white border border-gray-200 text-gray-700 px-4 py-2.5 text-sm rounded-lg flex items-center hover:bg-gray-100 transition-colors"
              >
                <i className="bx bx-image mr-2 text-blue-600"></i>
                {formEvento.imagen ? "Cambiar imagen" : "Seleccionar imagen"}
              </button>
              <span className="ml-3 text-sm text-gray-500 overflow-hidden whitespace-nowrap overflow-ellipsis flex-1">
                {formEvento.imagen
                  ? formEvento.imagen.name
                  : "Ninguna imagen seleccionada"}
              </span>
              <input
                id="evento-image-upload"
                type="file"
                name="imagen"
                accept="image/png, image/jpeg, image/jpg"
                onChange={handleFileChangeEvento}
                className="hidden"
                required
              />
            </div>
          </div>

          {/* Campos de Fecha y Hora en la misma fila */}
          <div className="mb-6 flex gap-4">
            {/* Campo de Fecha */}
            <div className="w-1/2">
              <div className="text-center mb-1">
                <label className="text-sm font-medium text-gray-700">
                  Fecha
                </label>
              </div>
              <input
                type="date"
                name="fecha"
                value={formEvento.fecha}
                onChange={handleInputChangeEvento}
                className="w-full px-4 py-3.5 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200 text-sm"
                required
              />
            </div>

            {/* Campo de Hora */}
            <div className="w-1/2">
              <div className="text-center mb-1">
                <label className="text-sm font-medium text-gray-700">
                  Hora
                </label>
              </div>
              <input
                type="time"
                name="hora"
                value={formEvento.hora}
                onChange={handleInputChangeEvento}
                className="w-full px-4 py-3.5 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200 text-sm"
                required
              />
            </div>
          </div>

          {/* Campo de Ubicación */}
          <div className="mb-6">
            <div className="text-center mb-1">
              <label className="text-sm font-medium text-gray-700">
                Ubicación
              </label>
            </div>
            <input
              type="text"
              name="ubicacion"
              value={formEvento.ubicacion}
              onChange={handleInputChangeEvento}
              className="w-full px-4 py-3.5 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200 text-sm"
              placeholder="Dirección del evento"
              required
            />
          </div>

          {/* Campo de Descripción */}
          <div className="mb-6">
            <div className="text-center mb-1">
              <label className="text-sm font-medium text-gray-700">
                Descripción
              </label>
            </div>
            <textarea
              name="descripcion"
              value={formEvento.descripcion}
              onChange={handleInputChangeEvento}
              className="w-full px-4 py-3.5 bg-gray-50 border-0 rounded-xl focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all duration-200 text-sm resize-none"
              rows="3"
              placeholder="Describe el evento..."
              required
            />
          </div>

          <button
            type="submit"
            className="text-white w-full bg-blue-800 hover:bg-blue-900 font-medium rounded-lg text-sm px-5 py-2.5 text-center flex items-center justify-center"
          >
            <i className="bx bxs-save text-white mr-2"></i> Registrar
          </button>
        </form>
      </div>

      {/* Tabla de eventos */}
      <div className="sm:col-span-1 flex justify-center w-full tamanoConenedor scrollbar styleScrollbar margenResultado">
        <div className="flex flex-col w-full">
          <h3 className="text-xl font-semibold text-[#1E429F] mb-3 flex items-center justify-center">
            <i className="bx bxs-calendar text-[#1E429F] mr-2"></i> Eventos
            registrados
          </h3>
          <div className="w-full overflow-x-auto">
            <table className="min-w-full bg-white shadow-md rounded-lg overflow-hidden">
              <thead className="bg-gray-100 border-b">
                <tr>
                  <th className="w-1/12 text-center font-semibold px-6 py-3 text-sm text-gray-700">
                    #
                  </th>
                  <th className="w-1/4 text-center font-semibold px-6 py-3 text-sm text-gray-700">
                    Nombre
                  </th>
                  <th className="w-1/4 text-center font-semibold px-6 py-3 text-sm text-gray-700">
                    Fecha
                  </th>
                  <th className="w-1/3 text-center font-semibold px-6 py-3 text-sm text-gray-700">
                    Ubicación
                  </th>
                  <th className="text-center font-semibold px-6 py-3 text-sm text-gray-700">
                    Acciones
                  </th>
                </tr>
              </thead>
              <tbody className="text-gray-700 divide-y divide-gray-200">
                {typeof evento !== "undefined" && evento.length !== 0 ? (
                  evento.map((item) => (
                    <tr className="text-sm hover:bg-gray-50" key={item.id}>
                      <td className="text-center py-3 px-4">{item.id}</td>
                      <td className="text-center py-3 px-4">{item.nombre}</td>
                      <td className="text-center py-3 px-4">{item.fecha}</td>
                      <td className="text-center py-3 px-4">
                        {item.ubicacion}
                      </td>
                      <td className="text-center py-3 px-4">
                        <div className="flex justify-center space-x-2">
                          <button
                            onClick={() =>
                              window.open(
                                `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                                  item.ubicacion
                                )}`,
                                "_blank"
                              )
                            }
                            className="bg-blue-600 hover:bg-blue-700 rounded-md flex items-center justify-center text-white p-2 w-10 h-10"
                            title="Ver ubicación en Google Maps"
                          >
                            <i className="bx bx-map-pin text-xl"></i>
                          </button>

                          <button
                            onClick={() => handleOpenDeleteEventoModal(item)}
                            className="bg-red-600 hover:bg-red-700 rounded-md flex items-center justify-center text-white p-2 w-10 h-10"
                            title="Eliminar evento"
                          >
                            <i className="bx bx-trash text-xl"></i>
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="5" className="text-center py-4 text-gray-500">
                      No hay eventos registrados
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabEventos;
